import { useCallback, useEffect, useRef } from 'react';
import { KANMON_CONNECT } from '@kanmon/web-sdk';
import ProviderStore from 'store/Provider';
import KanmonStore, { acquireKanmon, refreshKanmonInfo, KanmonUiState } from 'store/Kanmon';
import { TKanmonInfo } from 'types/common';

const useKanmonConnect = (generateToken?: boolean, onHide?: () => void): [
    typeof KANMON_CONNECT | undefined, TKanmonInfo | undefined, boolean, () => Promise<void>, KanmonUiState,
] => {
    const [getProvider] = ProviderStore.useStore();
    const providerId = getProvider('data')?.id;
    const [get] = KanmonStore.useStore();
    const saved = get('snapshot');
    const snapshot = saved?.providerId === providerId ? saved : undefined;
    const hideCallback = useRef(onHide);
    hideCallback.current = onHide;
    const applyProvider = useRef<number>();

    useEffect(() => {
        if (providerId) return acquireKanmon(providerId, () => hideCallback.current?.());
    }, [providerId]);
    useEffect(() => {
        if (!generateToken) {
            applyProvider.current = undefined;
        } else if (providerId && (!applyProvider.current || applyProvider.current === providerId)) {
            // An Apply click belongs to its initiating account, including StrictMode remounts.
            applyProvider.current = providerId;
            refreshKanmonInfo(providerId, { createIfMissing: true });
        }
    }, [generateToken, providerId]);
    const refresh = useCallback(async () => {
        if (providerId) await refreshKanmonInfo(providerId, { refreshAfterPending: true });
    }, [providerId]);

    return [snapshot?.connect, snapshot?.info, snapshot?.loading ?? !!providerId, refresh,
        snapshot?.ui ?? { status: providerId ? 'loading' : 'idle' }];
};

export default useKanmonConnect;
